<template>
    <div class="highlights">
        <h2 class="card-title">Club Highlights</h2>
        <p style="font-size: 20px; font-weight: 400;">Stay connected with the latest happenings at our club</p>
        <div class="cards">
            <LandingCard v-for="(card, index) in dataList2" :key="index" :title="card.title" :content="card.description"
                :icon="card.icon" />
        </div>

        <div class="legacy-sport" v-if="dataList != null">
            <div>
                <h2>{{ title }}</h2>
                <p v-html="description"></p>
                <!-- <button class="register">Join Now</button> -->
                <button class="register" @click="joinUs()">
                    <p style="margin: 0%; padding: 0%;">Join Us</p>
                    <ArrowRight style="margin: 0%; padding: 0%;" />
                </button>
            </div>
            <div>
                <img :src="image" alt="" srcset="">
            </div>
        </div>
    </div>
</template>

<script setup>
import router from '@/router';
import LandingCard from './CommonCard/LandingCard.vue';
import { HomeIcon, CalendarIcon, UsersIcon, ArrowRight } from "lucide-vue-next";
import axios from 'axios';
import { ref, onMounted, onBeforeUnmount } from "vue";

let base_url = process.env.VUE_APP_BASE_LIVE_URL
const dataList = ref([]);
const dataList2 = ref([]);
const title = ref('');
const description = ref('')
const image = ref('');

const icons = [HomeIcon, CalendarIcon, UsersIcon];

onMounted( async () => {
  await listGallery();
  await listHighlight();
  
});

onBeforeUnmount( async () => {
  
});
// Action methods
const listGallery = async () => {
  try {
    const response = await axios.get('/list_club_highlight_ext_list.php', { });

    dataList.value = response.data.data[0]
    title.value = dataList.value.title
    description.value = dataList.value.description
    image.value = `${base_url}/${dataList.value.banner_image}`

  } catch (error) {
    console.error(error.message);
  }
};

const listHighlight = async () => {
  try {
    const response = await axios.get('/list_club_highlight.php', { });

    if (response.data.status) {
      dataList2.value = response.data.data.map((item, index) => ({
        ...item,
        icon: icons[index % icons.length]   // rotate 3 icons
      }));
    } else {
      console.error(response.data.message);
    }

  } catch (error) {
    console.error(error.message);
  }
};



const joinUs = () => {
    router.push("application-forms")
}
</script>

<style scoped lang="scss">
.highlights {
    max-width: 90%;
    margin: auto;
    margin-top: 5rem;
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: center;
    align-items: center;
    .card-title{
        font-size: 48px; 
        font-weight: 400;
    }
    .cards {
        display: flex;
        flex-wrap: wrap;
        gap: 30px;
        width: 100%;
        justify-content: center;
    }
}

.legacy-sport {
    margin-top: 5rem;
    max-width: 80%;
    // margin: auto;
    display: flex;
    justify-content: space-between;
    gap: 30px;
    align-items: center;

    div {
        display: flex;
        flex-direction: column;
        justify-content: start;
        align-items: start;

        h2 {
            text-align: left;
            font-size: 48px;
            font-weight: 400;
            font-family: "Open Runde", sans-serif;
            max-width: 522px;

        }

        p {
            text-align: left;
            font-size: 20px;
            font-weight: 500;
            font-family: "Open Runde", sans-serif;
            max-width: 522px;
        }

        img {
            max-width: 474px;
            height: 374px;
            border-radius: 20px;
        }

        .register {
            background-color: #ed4e24;
            border: 2px solid #0000001f;
            color: white;
            border-radius: 30px;
            font-family: "Open Runde", sans-serif;
            font-size: 16px;
            padding: 10px 20px;
            cursor: pointer;
            transition: 0.3s ease;
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 10px;
        }
    }
}

@media (max-width: 768px) {
    .highlights {
        max-width: 100%;
    }

    .legacy-sport {
        flex-direction: column;
        gap: 10px;
        max-width: 100%;
        padding: 10px;
        border-radius: 20px;
        margin-top: 20px;

        div {
            h2 {
                text-align: left;
                font-size: 36px;
                font-weight: 400;
                font-family: "Open Runde", sans-serif;
                max-width: 100%;

            }

            p {
                text-align: left;
                font-size: 16px;
                font-weight: 500;
                font-family: "Open Runde", sans-serif;
                max-width: 100%;
            }

            img {
                max-width: 100%;
                height: auto;
                border-radius: 20px;
            }
        }

    }
    .card-title{
        font-size: 35px; 
    }
}
</style>
